export default __webpack_public_path__ + "static/media/fb.f753c9c5.svg";